export function addEventListener(el: Element, eventName: string, eventHandler: EventListener, selector?: string) {
  if (selector) {
    const wrappedHandler = (e: Event) => {
      if (!e.target) return;
      if (!(e.target instanceof Element)) return;
      const el = e.target.closest(selector);
      if (el) {
        eventHandler.call(el, e);
      }
    };
    el.addEventListener(eventName, wrappedHandler);
    return wrappedHandler;
  } else {
    const wrappedHandler = (e: Event) => {
      eventHandler.call(el, e);
    };
    el.addEventListener(eventName, wrappedHandler);
    return wrappedHandler;
  }
}
